/**
 * Floor serial scan/submit gate for Clamp QC (ticket 398).
 * Barcode wedges append Enter after each read; a double-scan is two submits in quick succession.
 */

/** Ignore HID / wedge keystrokes briefly after submit so a trailing scan cannot hit the modal keypad. */
export const CLAMP_QC_FLOOR_KEYBOARD_COOLDOWN_MS = 1500;

export function armClampQcFloorKeyboardCooldown(
  blockedUntilRef: { current: number },
  nowMs: number = Date.now(),
): number {
  const until = nowMs + CLAMP_QC_FLOOR_KEYBOARD_COOLDOWN_MS;
  blockedUntilRef.current = Math.max(blockedUntilRef.current, until);
  return blockedUntilRef.current;
}

export function isClampQcFloorKeyboardBlocked(
  blockedUntilRef: { current: number },
  nowMs: number = Date.now(),
): boolean {
  return blockedUntilRef.current > nowMs;
}

export function shouldIgnoreClampQcFloorSerialScan(options: {
  submitInFlight: boolean;
  inspectionDetailModalOpen: boolean;
  keyboardBlockedUntilMs?: number;
  nowMs?: number;
}): boolean {
  if (options.submitInFlight || options.inspectionDetailModalOpen) {
    return true;
  }
  if (options.keyboardBlockedUntilMs != null && options.keyboardBlockedUntilMs > (options.nowMs ?? Date.now())) {
    return true;
  }
  return false;
}

export function tryBeginClampQcSerialSubmit(inFlightRef: { current: boolean }): boolean {
  if (inFlightRef.current) {
    return false;
  }
  inFlightRef.current = true;
  return true;
}

export function endClampQcSerialSubmit(inFlightRef: { current: boolean }): void {
  inFlightRef.current = false;
}
